/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: 'Revisione AI',
    AIReviewFailed: 'Revisione AI non riuscita',
    AIReviewPassed: 'Revisione AI superata',
    AIReviewStatus: 'Stato della revisione AI',
    AIReviewing: 'Revisione AI è in fase di revisione',
    America: {},
    CheckSupportInstall: 'Verificare se il retrofit è supportato',
    ImporterCommunityDisplayName: "Nome visualizzato della comunità dell'importatore",
    ImporterContactEmail: "E-mail di contatto dell'importatore",
    IndicatorLight: 'Indicatore luminoso',
    Instruction: 'Avviso',
    MostPicture4OrVideo: '(Massimo 4 immagini / 1 video)',
    PleaseContactPersonnelCommunicating: 'Contatta il personale CFMOTO per comunicazioni',
    Redemptionservice: 'Servizio di riscatto',
    USD: {},
    UnbindingApplicationCommitment: {},
    aboutAccount: 'Informazioni sul conto',
    aboutVehicle: 'Informazioni sul veicolo',
    accountApplyRejected: "Richiesta di eliminazione dell'account respinta",
    accountCancel: "Richiesta di eliminazione dell'account",
    accountDeletExplain: "Guida all'eliminazione dell'account",
    accountDelete: "Eliminazione dell'account",
    accountDeleted: 'Account eliminato',
    accountFormatError: "Formato account errato/l'utente non esiste, è necessario abbinare il testo corrispondente in base alla causa effettiva.",
    accountNumber: 'Numero di account',
    action: 'Operazione',
    actionFail: 'operazione fallita',
    actionSuccess: 'Operazione riuscita',
    activeScore: 'Punteggio attivo',
    activeTrigger: 'Gli utenti attivano attivamente (Informazioni su APP: vai alla valutazione)',
    activity: 'Attività',
    activityCancel: "Cancellazione dell'evento",
    activityCover: 'Copertina attività',
    activityDetails: 'Dettagli attività',
    activityId: 'ID attività',
    activityList: 'Elenco attività',
    activityManagement: 'Gestione attività',
    activitySearch: 'Ricerca di attività',
    activityTime: 'Orario attività',
    activityTitle: 'Titolo attività',
    activityVenue: 'Sede attività',
    adaptable: 'Raccordi per',
    add: 'Aggiungi',
    addAccountDeletExplain: "Aggiungi avviso di cancellazione dell'account",
    addAuthenticationTime: 'Aggiungi tempo di autenticazione',
    addCanadaPrivacyPolicy: "Aggiungi l'Informativa sulla privacy del Canada",
    addCanadaTelematicsPolicy: "Aggiungere l'accordo telematico canadese",
    addCanadaUserPolicy: "Aggiungi il Contratto per l'utente canadese",
    addDashcamHelp: 'Aiuto dashcam aggiunto',
    addDataDeletExplain: 'Aggiungi avviso di cancellazione dati',
    addEmail: 'Nuova email',
    addExhibitionCategory: {},
    addExhibitionSeries: {},
    addHelpConfiguration: 'Aggiunta di aiuto per illustrare la configurazione',
    addInformationCategory: 'Aggiungi una nuova categoria di informazioni',
    addInformationContent: 'Aggiungi nuovi contenuti informativi',
    addKolUserAuthentication: "Aggiungi l'autenticazione dell'utente KOL",
    addPicture: 'Aggiungi immagine',
    addPrivacyAgreement: 'Nuovo accordo sulla privacy',
    addPrivacySubmitSure: "La data di entrata in vigore e la descrizione della modifica della nuova informativa sulla privacy non possono essere modificate dopo l'invio. Conferma l'invio.",
    addPushConfiguration: 'Aggiungi configurazione push',
    addQuestion: {},
    addSdkStaement: 'Aggiungi dichiarazioni SDK',
    addServiceIntroduce: 'Introduzione ai nuovi servizi',
    addShowroomModel: 'Aggiungi modelli di showroom',
    addThisUser: 'Aggiungi questo utente',
    addTopic: 'Aggiungi un argomento',
    addUser: 'Aggiungi utente',
    addUserAgreement: 'Nuovo accordo utente',
    addUserRole: 'Aggiungi ruolo utente',
    addVehicleModel: 'Nuovi modelli',
    addVehicleModelCategory: 'Categoria di veicoli nuovi',
    addVideo: 'Aggiungi video',
    addedBy: 'Aggiunto da',
    additionalFeedback: 'Feedback aggiuntivi',
    administratorUnbind: 'Dissocia amministratore',
    afternoon: 'Pomeriggio',
    agreeServiceAgreement: 'Attivando il servizio, accetti il Contratto di Servizio',
    agreeSignOut: 'Concorda a terminare',
    agreementContent: 'Accordo',
    all: 'Tutto',
    allArea: 'Paese/regione di destinazione',
    allComment: 'Tutti i commenti',
    allImportSuccess: 'Importazione completata, tutto importato con successo.',
    allServicesSimultaneously: 'Tutti i servizi',
    allUser: 'Tutti gli utenti',
    allVehicleModel: 'Tutti i modelli',
    alreadyOver: 'Tutto qui',
    ambientLightControl: 'Controllo della luce ambientale',
    amount: 'Importo',
    android: 'Androide',
    answer: {},
    answerOta1: "OTA significa che il veicolo scarica il software firmware più recente dal cloud attraverso la rete cellulare e puoi aggiornare il veicolo online tramite CFMOTO RIDE per ottimizzare continuamente l'esperienza di guida",
    answerOta2:
      'Quando è possibile aggiornare la nuova versione del display TFT, riceverai la notifica di aggiornamento. Se nella parte inferiore della pagina corrente viene visualizzato %s, significa che non è necessario aggiornare il display TFT del veicolo.',
    answerOta3: "Puoi fare clic su %s nell'angolo in alto a destra per saperne di più sulle istruzioni operative OTA in anticipo",
    anyCar: 'Eventuale auto?',
    appMessagePushCountLimit: 'Hai raggiunto il limite di invii push per questo mese (2 volte/mese). Il contenuto modificato può essere salvato come bozza. Vuoi salvarlo?',
    appPush: 'Push app',
    appRating: 'Gestione del meccanismo di punteggio',
    appType: 'Sistema telefonico',
    appVersion: "Versione dell'APP",
    applicableCountry: {},
    applicableCountryName: {},
    applyTime: 'Data di richiesta',
    applyUnbinding: 'Applicare il disincaglio',
    appointmentReleaseTime: "Orario di rilascio dell'appuntamento",
    approval: 'Approvate',
    arrivalNumberDescription: 'numero di dispositivi che hanno ricevuto la notifica',
    arrivalNumberDescription0: "Il numero effettivo degli arrivi al terminale del dispositivo dopo l'invio del messaggio di avviso (gli arrivi dopo 5 giorni non verranno conteggiati).",
    arrivalNumberVolume: 'Numero di arrivi',
    askAllowUserSpeakInCommunity: "Sei sicuro di permettere all'utente bannato di postare nella comunità",
    askApproveIt: 'Sei sicuro di voler approvare',
    askDeleteCategory: {},
    askDeleteInformactionCategory: 'Se eliminare questa categoria di informazioni',
    askDeleteInformationContent: 'Se eliminare il contenuto informativo',
    askDeleteKolUserAuthentication: 'Sei sicuro di eliminare questa autenticazione utente KOL?',
    askDeleteOfficialAuth: "Sei sicuro di voler eliminare l'autenticazione ufficiale per questo account?",
    askDeleteQuestion: {},
    askDeleteThisActivity: 'Sei sicuro di voler eliminare questa attività',
    askDeleteThisBanner: 'Sei sicuro di voler eliminare questo Banner',
    askDeleteThisComment: 'Sei sicuro di voler cancellare questo commento',
    askDeleteThisPost: 'Sei sicuro di voler eliminare questo post',
    askDeleteThisTopic: 'Sei sicuro di voler eliminare questo argomento',
    askDeleteVehicleType: 'Sei sicuro di eliminare il modello del veicolo',
    askDeleteVehicleTypeCategory: 'Se eliminare questa categoria di modello',
    askDeleteVehicleTypeDetails: "Se eliminare i dettagli del modello dell'auto",
    askDeleteVehicleTypeSeries: 'Se eliminare questa serie di modelli',
    askLogout: 'Sicuro di voler lasciare il sistema?',
    askNotApproveIt: 'Sei sicuro di voler non approvare',
    askSaveSettings: 'Le impostazioni non sono state ancora salvate, vuoi salvarle?',
    associatedPostNumber: 'Numero dei post associati',
    associatedPosts: 'Post associati',
    associatedVehicle: 'veicolo associato',
    assoclatedContent: 'Contenuto associato',
    atmosphereCContent: 'Le impostazioni non sono state ancora salvate, vuoi salvarle?',
    atmosphereContent1Msg1: "Dopo aver attivato la funzione, il telefono cellulare attiva il Bluetooth e l'app continua a funzionare. Quando ci si avvicina al veicolo da lontano a vicino, il veicolo può essere sbloccato automaticamente e acceso.",
    atmosphereContent1Msg2: 'Se non è normalmente sbloccato e acceso, premere il pulsante di accensione del veicolo per sbloccare e accendere',
    atmosphereContent1Msg3: 'Lo sblocco automatico di prossimità verrà attivato solo una volta prima che il bluetooth venga disconnesso',
    atmosphereContent2Msg1: "Dopo l'accensione della funzione, il veicolo si spegne automaticamente dopo 5 secondi dopo lo spegnimento delle tre condizioni del veicolo, la velocità del veicolo è 0 e il tempio è caduto",
    atmosphereContent2Msg2: 'Avviando il veicolo durante il periodo di spegnimento automatico, la velocità del veicolo non è 0, o il tempio è messo via annullerà lo spegnimento automatico',
    atmosphereContent3Msg1:
      "Dopo l'attivazione della funzione, quando il veicolo è spento, il telefono cellulare accende il Bluetooth e l'APP continua a funzionare o porta la chiave fisica. Quando ci si avvicina al veicolo da lontano a vicino, le luci del veicolo lampeggeranno per accogliere gli ospiti",
    atmosphereContent3Msg2: 'Al fine di evitare che i frequenti trigger causino la perdita di potenza del veicolo, dopo che la funzione di benvenuto è stata attivata due volte entro 30 secondi, non riprenderà fino a 30 minuti dopo',
    atmosphereContent4Msg1: 'Dopo aver attivato la funzione, le luci lontane e anabbaglianti si accenderanno automaticamente per 10 secondi dopo lo spegnimento del veicolo',
    atmosphereIntroduce1: 'Vicino alle istruzioni di sblocco automatico',
    atmosphereIntroduce2: 'istruzioni per lo spegnimento automatico',
    atmosphereIntroduce3: 'Istruzioni di riattivazione automatica',
    atmosphereIntroduce4: 'Spegnimento ritardato delle luci',
    atmosphereSetINfo: "Le nuove impostazioni avranno effetto entro 1-3 minuti dall'accensione del veicolo, assicurarsi che il veicolo sia in una buona posizione del segnale",
    auditStatus: 'Stato della revisione',
    authType: 'Tipo di autenticazione',
    authenticatedName: 'Nome autenticato',
    avatar: 'Avatar',
    backApply: 'ritirare la domanda',
    backApplySuccess: 'ritiro della domanda andato a buon fine',
    backHome: 'Torna alla home page',
    bannerDisplayImages: 'Immagine dello striscione',
    bannerList: 'Elenco Banner',
    bannerManagement: 'Gestione Banner',
    bannerPictrure: 'Disegno di Banner',
    bannerSearch: 'Ricerca di Banner',
    bannerTitle: 'Titolo banner',
    baseService: 'Standard Edition\n',
    baseServicePay: 'Pagamento dei Standard Edition',
    baseServiceResetTimeRule: "L'ora di ripristino del servizio di base non può essere successiva all'ora corrente.",
    batchImport: 'Importazione batch',
    batchUser: 'Utenti batch',
    beijingTime: 'Ora UTC+8',
    belogCategory: 'categoria',
    belongCategory: {},
    bindDevice: 'Dispositivo di associazione',
    bindEmail: "Legare l'e-mail",
    bindVehicle: 'Legare il veicolo',
    bindingStatus: 'Stato di binding',
    bindingText1: '1.\tServizi telematici',
    bindingText10: '1.1.2.\tPianificazione del percorso durante la navigazione, compreso il calcolo della distanza tra i veicoli e la navigazione a piedi allo scopo di trovare un veicolo .',
    bindingText11: '1.2.\tInvio delle necessarie notifiche al Cliente in base alle condizioni del veicolo.',
    bindingText12:
      '1.2.1.\tCFMOTO invierà le notifiche al Cliente sulla manutenzione del veicolo (ad es. in base alla distanza totale percorsa dal Cliente, al momento in cui il Cliente acquista il veicolo, ai requisiti di tempo o distanza di guida per la manutenzione del veicolo) .',
    bindingText13:
      "1.2.2.\tSulla base dei dati del veicolo , CFMOTO invierà al Cliente segnalazioni di situazioni anomale; compresa l'analisi dei dati da parte dell'OEM (a seconda del modello) per fornire assistenza al cliente e ottimizzazione del follow-up del veicolo .",
    bindingText14: "1.3.\tSupporto nell'analisi della causa del sinistro qualora il Cliente segnali un grave sinistro del Veicolo.",
    bindingText15:
      "1.3.1.\tIn caso di incidente grave del Veicolo, ad esempio quando il Veicolo si ribalta o si ribalta su un fianco durante la guida, CFMOTO supporterà il Cliente su richiesta nel chiarire se l'incidente sia dovuto a un difetto del Veicolo o ad altre circostanze. La richiesta deve essere presentata a CFMOTO dal Cliente tramite il distributore/partner di vendita locale indicato nel Contratto di Vendita del Veicolo.",
    bindingText16: "1.3.2.\tNella misura in cui i dati disponibili lo consentano, CFMOTO valuterà i dati in relazione alla causa dell'incidente e fornirà al Cliente un rapporto corrispondente.",
    bindingText17: '1.4.\tAssistenza al Cliente per il recupero del Veicolo dopo lo smarrimento del Veicolo .',
    bindingText18:
      "1.4.1.\tIn caso di smarrimento del Veicolo, CFMOTO fornirà al Cliente i dati sulla posizione del Veicolo e altri dati utili sullo stato del Veicolo (come la posizione dell'ultima attivazione, lo stato attuale del veicolo, ecc.) su richiesta e se disponibili.",
    bindingText19: '1.4.2.\tLa richiesta deve essere presentata a CFMOTO dal Cliente tramite il distributore/partner di vendita locale indicato nel Contratto di Vendita del Veicolo.',
    bindingText2:
      'CFMOTO Powersports, Inc. (di seguito denominato " CFMOTO " ) fornisce servizi telematici per veicoli al cliente che ha acquistato il veicolo CFMOTO (di seguito denominato "Cliente" ). Per questi servizi, CFMOTO utilizza i dati registrati dal Veicolo sul Veicolo e sul suo comportamento di guida nel periodo di tempo pertinente. In dettaglio si tratta dei seguenti dati:',
    bindingText20: '1.5.\tSegnalazione problemi post vendita .',
    bindingText21: '1.5.1.\tCFMOTO raccoglie da remoto le notifiche dei codici di errore inviate dal Veicolo in caso di malfunzionamento dei suoi componenti e fornisce le relative informazioni su richiesta del Cliente direttamente al Cliente.',
    bindingText22: '1.5.2.\tLa richiesta deve essere presentata a CFMOTO dal Cliente tramite il distributore/partner di vendita locale indicato nel Contratto di Vendita del Veicolo.',
    bindingText23: '2.\tRestrizioni ed Esclusioni di Servizio',
    bindingText24:
      "2.1.\tSi precisa espressamente che modifiche strutturali o di altra natura tecnica al Veicolo possono limitare o addirittura rendere impossibile l'erogazione dei servizi, in quanto i servizi dipendono dal corretto conferimento dei dati del veicolo.",
    bindingText25: "2.2.\tLaddove tali servizi non possono essere forniti a causa dell'esecuzione di dati o reti di telecomunicazione di terze parti , è esclusa qualsiasi responsabilità di CFMOTO.",
    bindingText26: '3.\tRiservatezza',
    bindingText27:
      "CFMOTO rispetterà le normative sulla protezione dei dati applicabili durante il trattamento dei dati personali in relazione al veicolo CFMOTO . I termini dell'informativa sulla privacy di C FMOTO sono definiti in questa APP CFMOTO RIDE . Come integrazione all'informativa sulla privacy , la presente informativa è conforme all'informativa sulla privacy . E il Cliente può fare riferimento all'informativa sulla privacy per alcuni contenuti relativi al trattamento dei dati non coperti da questa informativa.",
    bindingText28: '4.\tAssistenza clienti',
    bindingText29:
      '4.1.\tIl Cliente può sentirsi libero di inviare domande, commenti o dubbi relativi alla privacy a CFMOTORIDEAPP@cfmotousa.com o scrivere a: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, MN 55447. Il Cliente può anche chiamare Relazioni con i clienti CFMOTO al numero (888) 823-6686. ',
    bindingText3: "Dati sul comportamento di guida dell'utente : inclusi accelerazione, decelerazione, velocità, curvatura, ultimo tempo di guida e ultimo chilometraggio di guida .",
    bindingText30: '5.\tRevisioni _',
    bindingText31: '5.1.\tCFMOTO si riserva il diritto di modificare questo avviso in qualsiasi momento, ma pubblicheremo le revisioni su CFMOTO RIDE App e/o fornire un avviso prima di farlo, se del caso.',
    bindingText4:
      'Dati sullo stato del veicolo: si riferiscono allo stato in tempo reale del veicolo, inclusa la modalità di guida, il carburante residuo, il consumo di carburante istantaneo, il chilometraggio, la marcia in tempo reale del veicolo, la velocità del motore, la pressione dei pneumatici, la temperatura dei pneumatici, i dati sulla tensione di attivazione della batteria , temperatura del liquido di raffreddamento, stato del blocco elettronico, versione del software del dispositivo intelligente, potenza del segnale dei dispositivi intelligenti, impostazione corrente del cruscotto.',
    bindingText5:
      'Dati di allarme del veicolo: dati di allarme da inviare se determinati dati superano un valore preimpostato, come temperatura del motore, velocità eccessiva, tempo di guida eccessivo, temperatura del liquido di raffreddamento elevata, movimento anomalo del veicolo, pressione dei pneumatici anomala, vibrazioni, ribaltamento, collisione , ecc . .',
    bindingText6: 'Informazioni Guasto Veicolo: si riferisce ai codici di guasto segnalati da ciascuna parte interna del Veicolo.',
    bindingText7: 'Dati sulla posizione del veicolo: si riferisce alla posizione geografica specifica del veicolo.',
    bindingText8: "1.1.\tFornitura _ il Cliente con servizi relativi al veicolo attraverso l' APP CFMOTO RIDE .",
    bindingText9: "1.1.1.\tAPP CFMOTO RIDE (compresa la visualizzazione della posizione del veicolo, l'impostazione delle informazioni e delle funzioni del veicolo, il controllo remoto dello stato del veicolo, ecc.).",
    bindingUser: 'Associa utente',
    bothServices: 'Entrambi i servizi',
    bound: 'Associato',
    businessType: 'Tipo di attività',
    button: 'Bottone',
    callbackedApply: 'Hai ritirato la richiesta di cancellazione del tuo account in data yyyy-MM-dd HH:mm:ss',
    callbackedApplySyncTip:
      "La tua richiesta di eliminazione dell'account è stata inviata il yyyy-MM-dd HH:mm:ss. Elimineremo definitivamente il tuo account e i dati correlati 15 giorni dopo aver ricevuto la richiesta. Dopo l'eliminazione, non sarai più in grado di utilizzare il servizio CFMOTO RIDESYNC. Per annullare l'eliminazione dell'account, torna su la pagina web o accedi all'APP entro 15 giorni per revocare la richiesta di eliminazione dell'account.",
    callbackedApplyTip:
      "La tua richiesta di eliminazione dell'account è stata inviata il yyyy-MM-dd HH:mm:ss. Elimineremo definitivamente il tuo account e i dati correlati 15 giorni dopo aver ricevuto la richiesta. Dopo l'eliminazione, non sarai più in grado di utilizzare il servizio CFMOTO RIDE. Per annullare l'eliminazione dell'account, torna su la pagina web o accedi all'APP entro 15 giorni per revocare la richiesta di eliminazione dell'account.",
    canadaPrivacyPolicy: 'Informativa sulla privacy canadese',
    canadaTelematicsPolicy: 'Accordo telematico canadese',
    canadaUserPolicy: "Contratto d'uso canadese",
    canadianAgreementText: "Testo dell'Accordo Canadese",
    cancel: 'Annulla',
    cancellationAgreement: 'Condizioni di cancellazione',
    cancelled: 'Annullate',
    carOwner: 'Proprietario',
    carUserScore: 'Valutazioni del proprietario del veicolo',
    cardPass: "Verifica dell'identità riuscita!",
    cfmotoName: 'CFMOTO',
    changeCodeValidate: "Passa all'autenticazione tramite codice di verifica",
    changeDescriptionType: 'Modifica descrizione',
    changeDescriptionTypeSelectNo: 'Non comporta modifiche alla normativa sul trattamento dei dati personali',
    changeDescriptionTypeSelectYes: 'Cambiamenti normativi riguardanti il trattamento dei dati personali',
    changeEmail: "Modificare l'e-mail",
    changeEmailInfo: "Passa all'e-mail",
    changeFail: 'La modifica dello stato non è riuscita',
    changeOne: 'Modifica',
    changePassValidate: "Passa all'autenticazione tramite password",
    changePasswordFailed: 'Modifica della password non riuscita',
    changePasswordSuccessful: 'Modifica password riuscita',
    changePhoneInfo: 'Passa al numero di telefono',
    changeStore: 'Cambia negozio',
    changeSuccess: 'Stato modificato con successo',
    channelType: 'canale di feedback',
    characterLimitExceeded: 'Limite di caratteri superato',
    checkConfigurationTwo: 'Chinês ou Inglês %s não está totalmente configurado, por favor verifique',
    checkCopyWriting: 'Il contenuto cinese o inglese non è compilato, controlla',
    checkEmpty: '%s è vuoto, controlla',
    checkEmptyEnglish: 'Inglese incompleto. Verifica',
    checkTriggerType: "C'è una condizione del meccanismo di attivazione che non è stata compilata, controlla",
    checkUpdate: 'verificare gli aggiornamenti',
    cityFilter: 'Filtro della città',
    clickImmediateFeedback: 'Fai clic per fornire un feedback ora',
    clickNumber: 'Il numero di clic',
    clickNumberDescription: 'numero di notifiche cliccate dagli utenti',
    clickNumberVolume: 'Numero di clic',
    clickToFeedback: 'Clicca per il feedback',
    clicks: 'Clic',
    closeNum: 'chiusura',
    closeTask: 'Attività annullata',
    code: 'Codice di verifica',
    colorPicture: 'Immagine blocco colore',
    comment: 'Commento',
    commentContent: 'Commenti',
    commentList: 'Elenco commenti',
    commentNumber: 'Numero di commenti',
    commentTime: 'Ora di commento',
    communication: 'nella comunicazione',
    community: 'Comunità',
    communityManagement: 'Gestione della comunità',
    communityRule: 'Regole della comunità',
    completePuzzle: 'Per favore completa il puzzle',
    completed: 'completato',
    condition: 'condizione',
    configureLanguage: 'Configura la lingua',
    configurePicture: 'Configura immagine',
    confirm: 'Conferma',
    confirmDeletePictures: 'Conferma per eliminare questa immagine',
    confirmRedeem: 'Conferma di riscattare',
    confirmReviewNoPass: 'Conferma di non superare la revisione',
    confirmReviewPass: 'Conferma di superare la revisione',
    consultDealer: 'Si prega di consultare il proprio rivenditore locale',
    contact: "La tua richiesta di cancellazione dell'account è stata respinta. In caso di domande, contattare it@cfmoto.com per la consultazione.",
    contactMail: 'Indirizzo e-mail',
    contactMethod: 'Contattaci',
    contactUs: 'Contattaci',
    content: 'Contenuto',
    contentType: 'Tipo di contenuto',
    copyFail: 'Copia non riuscita',
    copyLink: 'Copia link',
    copySuccess: 'Copiato con successo',
    copyWriting: 'Contenuti pop-up',
    country: 'Paese/regione',
    countryCode: 'Prefisso internazionale',
    countryName: 'Paese',
    countryNumber: 'Prefisso internazionale',
    countryRegion: 'Paese/regione',
    create: 'Nuova aggiunta',
    createBy: 'Creatore',
    createStore: 'Crea un negozio',
    createTime: 'tempo di creazione',
    cs_CZ: 'ceco',
    currency: 'Valuta',
    currentConfig: {},
    currentCountryStoreTotal: 'Numero totale di negozi nel paese attuale',
    currentRedemptionRatio: 'Rapporto di riscatto corrente',
    currentTime: 'Ora attuale',
    customPage: 'Pagina personalizzata',
    customSettings: 'Colonne personalizzate',
    dashcamHelp: 'Aiuto dashcam',
    dataDeletExplain: "Guida all'eliminazione dei dati",
    dataDelete: 'Eliminazione dei dati',
    dataDeleteApply: 'Richiesta di eliminazione dei dati',
    dataFormatError: 'Errore di formato dei dati',
    dataPermissionScope: 'Ambito di autorizzazione dati',
    dataType: 'Tipo di dati',
    dayOne: 'giorni una volta',
    days: 'giorno',
    daysAgo: '%s giorni fa',
    de_DE: 'Tedesco',
    dealDate: 'Ora di gestione',
    dealerOperationList: 'Elenco operazioni rivenditore',
    dealerOperationQuery: 'Ricerca operazioni rivenditore',
    dealerOperationRecord: 'Registro delle operazioni del concessionario',
    dealerStore: 'Negozi concessionari',
    dealerStoreImportTempateName: 'Modello di importazione negozio rivenditore',
    dealerStoreQuery: 'Query dei negozi concessionari',
    dealers: 'Importatore',
    default: 'Predefinito',
    defaultMap: 'Mappa predefinita',
    delete: 'Elimina',
    deleteAccountSYNCStep: "Puoi seguire questi passaggi per richiedere l'eliminazione del tuo account CFMOTO RIDESYNC",
    deleteAccountStep: "Puoi seguire questi passaggi per richiedere l'eliminazione del tuo account CFMOTO RIDE",
    deleteDataSYNCStep: "Puoi seguire questi passaggi per richiedere l'eliminazione dei tuoi dati CFMOTO RIDESYNC",
    deleteDataStep: "Puoi seguire questi passaggi per richiedere l'eliminazione dei tuoi dati CFMOTO RIDE",
    deleteFail: 'Cancellazione fallita',
    deleteFinish: 'Eliminazione completata',
    deleteKolUserAuthentication: "Elimina l'autenticazione dell'utente KOL",
    deleteStore: 'Cancella il negozio',
    deleteSuccess: 'Cancellazione riuscita',
    deleteTip: 'Sei sicuro di voler eliminare questo post? Una volta eliminate, le informazioni non possono essere recuperate',
    deleteVersionWarn: 'Indica se eliminare questo record di versione',
    deleteVideo: 'Eliminare questo video?',
    detailAddress: 'Indirizzo dettagliato',
    details: 'Dettagli',
    determine: 'Sicura',
    deviceCodeGet: 'Ottieni il codice del dispositivo:',
    deviceContent:
      "Il codice dell'apparecchiatura del ricevitore della recinzione elettronica (denominato: chiave) è una stringa di codici di 10 cifre. Il codice dell'apparecchiatura, il codice QR e il marchio CE sono stampati sull'adesivo autoadesivo in PVC argento. Ci sono tre etichette in totale, una è stata affissa sulla carrozzeria del veicolo (è necessario sollevare il cuscino del sedile per vederla); gli altri due vengono riposti nella borsa degli accessori del veicolo. (Si consiglia agli utenti di apporre l'etichetta sul manuale del veicolo o sul telecomando)\nTenere premuto ON per aprire la chiave e inserire il codice QR sul retro della chiave nel riquadro di scansione",
    deviceNo: 'Numero dispositivo associato',
    deviceNumber: 'Numero del dispositivo',
    deviceTitle: 'Verifica codice',
    digitalKey: 'chiave digitale',
    digitalKeyDesc: 'Non è necessario portare con sé una chiave fisica, supporta lo sblocco del veicolo dopo la connessione tramite APP Bluetooth (supportato da alcuni modelli)',
    directRelease: 'Pubblicazione diretta',
    disagree: "Non sono d'accordo",
    displayNumberDescription: 'numero di notifiche mostrate sui dispositivi',
    displayNumberVolume: 'Numero di visualizzazioni',
    displayOrder: {},
    displayPicture: {},
    donwloadTemplateDescription: {},
    download: 'Scarica',
    downloadFailFile: 'Scarica file non riuscito',
    downloadSuccessful: 'Download riuscito',
    downloadTemplate: 'Scarica il modello',
    downloading: 'Scaricando...',
    ebookChoice: {},
    ebookEmpty: {},
    ebookPlaceholder: {},
    ebookSwitch: {},
    ebookTitle: {},
    edit: 'modificare',
    editAccountDeletExplain: "Avviso di cancellazione dell'account",
    editActivity: 'Modifica attività',
    editAppRating: 'Modifica il meccanismo di valutazione',
    editBanner: 'Modifica Banner',
    editCanadaPrivacyPolicy: "Modifica l'Informativa sulla privacy del Canada",
    editCanadaTelematicsPolicy: "Modifica l'accordo telematico canadese",
    editCanadaUserPolicy: "Modifica il contratto d'uso per il Canada",
    editDashcamHelp: 'Aiuto dashcam modificato',
    editDataDeletExplain: 'Modifica avviso di cancellazione dati',
    editExhibitionCategory: {},
    editExhibitionSeries: {},
    editFunctionIntro: {},
    editHelpConfiguration: 'L’editor aiuta a spiegare la configurazione',
    editInformation: 'Modifica informazioni',
    editInformationCategory: 'Modifica la categoria delle informazioni',
    editInformationContent: 'Modifica il contenuto delle informazioni',
    editKolUserAuthentication: "Modifica l'autenticazione dell'utente KOL",
    editModelSeries: 'Modifica serie di modelli',
    editPicture: 'Modifica immagine',
    editPushConfiguration: 'Modifica configurazione push',
    editRemark: 'Modifica note',
    editServiceIntroduce: {},
    editShowroomModel: 'Modifica modelli di showroom',
    editSuccess: 'Modificato con successo',
    editTime: 'Tempo di modifica',
    editUnbindingCommitment: {},
    editUser: 'Modifica utente',
    editVehicleModel: 'Modifica modello',
    editVehicleModelCategory: 'Modifica categoria di veicoli',
    effecting: 'In attesa di attivazione',
    effectiveTime: 'Data effettiva',
    electricVehicle: 'Veicolo elettrico',
    email: 'Email',
    emailAdress: 'Indirizzo email',
    emailAdressTip: "Nota: Questo indirizzo email viene utilizzato per contattare i clienti via email. Assicurarsi che l'indirizzo email sia corretto",
    emailBindingFailed: 'Blocco e-mail non riuscito',
    emailContent: "Contenuto dell'e-mail",
    emailImportTemplate: "Modello di importazione dell'indirizzo email",
    emailImportTemplateToDownLoad: 'Gli indirizzi e-mail possono essere importati in batch, fare clic per scaricare',
    emailList: 'Elenco e-mail',
    emailManage: 'Gestione della posta elettronica',
    emailMass: 'Esplosione di e-mail',
    emailSearch: 'Domanda di posta elettronica',
    emailSendTip1: 'Note: Be sure to add the note in blue font below at the end of your email. If the text of your email is not in English, please translate it into the language you are using before adding it.',
    emailSendTip2: 'If you want to unsubscribe from such emails, go to the CFMOTO RIDE App, click the [Me] > [Settings] > [Message notification] to turn off the [Receive email marketing] function.',
    emailSendTip3: '*Emails without added notes will not be reviewed and approved.',
    emailText: 'E-mail',
    emailTitle: 'Soggetto',
    en_US: 'Inglese',
    enableStatus: 'Stato abilitato',
    enabled: 'abilitare',
    endTime: 'Ora di fine',
    endTimeLargeStartTime: "L'ora di fine deve essere successiva all'ora di inizio",
    enterAnswer: {},
    enterCategory: {},
    enterCodeToSafeAccount: 'Per garantire la sicurezza del tuo account, ti preghiamo di confermare le informazioni del tuo account che desideri eliminare, e inserisci la tua password o un codice di verifica per autenticare la tua identità.',
    enterCodeToSafeData: 'Per garantire la sicurezza dei tuoi dati, ti preghiamo di confermare le informazioni del tuo account, e inserisci la tua password o un codice di verifica per autenticare la tua identità.',
    enterIntroduceText: {},
    enterLink: {},
    enterPopupTitle: {},
    enterQueryConditionLookData: 'Dopo aver inserito le condizioni della query, è possibile visualizzare i dati',
    enterQuestion: {},
    enterQuestionAndAnswer: {},
    enterSureUrl: {},
    enterTypeOfLanguage: {},
    enterUnbindingCommitment: {},
    entrance: {},
    errorLatAndLon: 'La latitudine e la longitudine sono formattate in modo errato, si prega di controllare',
    errorLocation: {},
    es_ES: 'spagnolo',
    estimatedTime: 'Tempo stimato',
    everySet: 'Per impostazione',
    examineResultMessage: "Verificheremo i materiali dell'applicazione il prima possibile, si prega di prestare attenzione alla barra delle notifiche o al centro messaggi dell'APP in tempo.",
    example: 'precedente',
    exchange: 'Riscatta ora',
    exchangeDescription1:
      'Gentile proprietario di CFMOTO, il tuo veicolo è stato associato con successo. Hai ricevuto un anno di prova gratuita per i servizi intelligenti. \nScegli i servizi che desideri attivare: \n- Edizione Standard \n- MotoPlay Premium \nTi invitiamo a leggere e accettare i seguenti termini \nVisualizza il "Contratto di Servizio Intelligente" \n[Conferma]\t',
    exchangeDescription2:
      'Si prega di consultare il manuale elettronico per tutti i dettagli del veicolo. Potrai anche usufruire di un periodo di prova gratuita di 1 anno per tutti i servizi intelligenti CFMOTO RIDE, a partire dalla data del tuo primo abbinamento.\n [Chiudi] [Ho Capito]',
    exchangeDescription3:
      "Hai XXX km di chilometraggio disponibile. Riscatta ora per continuare a usufruire del servizio intelligente CFMOTO RIDE. Se non si intraprende alcuna azione, i dati relativi al chilometraggio saranno conservati per 30 giorni dopo la disconnessione dell'account. Il chilometraggio non riscattato sarà automaticamente cancellato e non potrà essere recuperato dopo questo periodo. \nSei sicuro di voler riscattare ora?\n [Sì] [No]\n\n*I benefici del chilometraggio riscattato saranno trasferiti insieme al veicolo per l'uso del prossimo proprietario.",
    exchangeDescription4: 'Hai XXX km di chilometraggio disponibile. Vuoi riscattare il tuo chilometraggio per continuare\n a usufruire gratuitamente del servizio intelligente CFMOTO RIDE?\n [Sì] [No]',
    exchangeDescription5:
      'Promemoria di servizio intelligente\n Gentile proprietario di CFMOTO: Mancano XXX giorni al termine del periodo di prova gratuita del servizio intelligente CFMOTO. Se attiva il servizio intelligente, questo sarà attivato entro 24 ore. Si prega di controllare attentamente. \n[Conferma]',
    exchangeDescription6: "Goditi un'esperienza di percorso migliore con MotoPlay, che offre servizi di proiezione e navigazione supportati da Google Maps.",
    exchangeRecords: 'Registro di riscatto',
    exchangeServiceTime: 'Hai il chilometraggio disponibile per riscattare le ore di servizio',
    exchangeSuccess: 'Riscattato con successo',
    exhibition: {},
    exhibitionCategory: {},
    exhibitionCategoryList: {},
    exhibitionCategorySearch: {},
    exhibitionSeries: {},
    exhibitionSeriesList: {},
    exhibitionSeriesSearch: {},
    exportContent: 'Esporta contenuto',
    exportExcel: 'Esporta su EXCEL',
    exportLengthExceedOfMonth: "Durata dell'esportazione non superiore a %s mesi",
    externalLink: 'Collegamento esterno',
    failed: 'Non riuscito',
    failedToPreview: 'Revisione non riuscita',
    feedBackResut: 'Risultati del feedback',
    feedBackTime: 'Tempo di feedback',
    feedBackVechle: 'Veicolo',
    feedbackAppQuestion:
      "Si prega di descrivere dettagliatamente l'ora in cui si è verificato il problema, la versione dell'APP, il modello di telefono cellulare, il percorso operativo e la descrizione del problema per aiutarci a individuare e risolvere rapidamente il problema!",
    feedbackDetails: 'Dettagli del feedback',
    feedbackGuideDesc: 'Per ulteriori informazioni, contattaci tramite il canale di feedback riportato di seguito',
    feedbackLabelFileList: "Caricare un'immagine",
    feedbackMapQuestion: {},
    feedbackMessageSubmitError: 'Feedback fallito',
    feedbackOtherQuestion: 'Descrivere quando è successo, come è successo e il problema.',
    feedbackReceived: 'Feedback ricevuto',
    feedbackRecord: 'Registro dei feedback',
    feedbackRulesFileListMaxSize: 'Il file caricato è troppo grande',
    feedbackRulesFileListOverType: 'Formato non supportato',
    feedbackSubmitTip: 'In caso di domande o commenti, puoi anche contattare il Centro assistenza clienti CFMOTO Messico direttamente tramite WhatsApp (+52 18115286003) o e-mail (servicioalclient@cfmoto.com.mx)',
    feedbackSuggest: 'Benvenuti a dare suggerimenti preziosi, prenderemo seriamente in considerazione le vostre idee.',
    feedbackSupplement: 'Aggiungi una descrizione del problema',
    feedbackText: 'Feedback',
    feedbackType: 'Tipo di feedback (scelta singola)',
    feedbackVehicleQuestion: 'Descrivere quando è successo, come è successo e il problema.',
    female: 'Femmina',
    fileCountExceed: 'Il numero di file supera il limite',
    fileSizeExceed: 'La dimensione del file supera il limite',
    fileUploadingPleaceWait: 'Caricamento file, attendere',
    finalOperator: {},
    firstBindDate: 'Orario della prima associazione del veicolo',
    firstMenu: 'Menu di primo livello',
    forcedUpgrade: 'Aggiornamento forzato',
    forgetPassword: 'Password dimenticata',
    fourCarOfNumber: 'Numero di utenti di veicoli a quattro ruote',
    fourWheel: 'Moto a quattro ruote',
    fourWheelConfig: {},
    fourWheeler: 'Quattro ruote',
    fourWheelerMostClicks: 'I modelli di quattro ruote con il maggior numero di clic',
    fourWheelowner: {},
    fr_FR: 'francese',
    frankfurt: 'francoforte',
    freeLastDayBasedata: 'Durata gratuita della edizione standard',
    freeLastDayMotoplay: 'Durata gratuita MotoPlay',
    friday: 'Venerdì',
    fuctionIntro: {},
    fullscreen: 'Schermo pieno',
    funServiceIntro: {},
    function: 'Funzione',
    functionConfiguration: {},
    functionConfigureTip: "La funzione è applicabile solo ai veicoli configurati a nome dell'importatore o degli utenti nel paese/regione a cui appartiene",
    functionDescription: {},
    functionDetail: {},
    functionIntroduce: 'Descrizione della funzione',
    functionSetting: {},
    functionalOverview: 'Panoramica delle funzioni',
    galleryEntrance: 'Ingresso della Galleria',
    galleryEntranceUploadRules: 'Requisiti del formato: jpg/jpeg/png, rapporto consigliato 4:3, dimensione non superiore a 5 MB',
    gender: 'Genere',
    generalAgreementText: "Testo dell'Accordo Generale",
    generalAlarm: 'Allarme generale',
    geofence: 'Recinto elettronico',
    getCarPosition: 'Ottieni la posizione del veicolo in tempo',
    getCode: 'Spedire',
    getExchangeRecordsError: 'Impossibile ottenere i registri di riscatto',
    goCustomPage: 'Vai alla pagina personalizzata',
    goOffline: 'Offline',
    goOnline: 'Online',
    goUrlLink: 'Vai al link URL',
    groupTrail: {},
    groupTrailConfig: {},
    guest: 'Niente auto',
    haveTwo: 'Entrambi',
    havedWrite: 'Compilato',
    havedWriteAll: 'siano stati compilati',
    havedWriteAllOrEmpty: 'sia compilato o vuoto',
    helpAndFeedback: 'Aiuto & feedback',
    helpCenter: 'Centro assistenza',
    helpConfiguration: 'Descrizione della configurazione',
    helpMessageHistoryDelete: 'Eliminare tutti i record di ricerca?',
    helpful: {},
    hint: 'Suggerimento',
    historyDelete: 'Eliminare tutti i record di ricerca?',
    home: 'Home page',
    homePage: 'Home page personale',
    hour: 'Ora',
    hoursAgo: '%s ore fa',
    iWantEnableStoreUserQuery: 'Voglio attivare la ricerca utenti del negozio',
    iWantToPostStatistics: 'Voglio pubblicare le statistiche',
    identification: 'Identificazione',
    identificationText: 'Identificazione',
    imageSizeExceed: "Carica un'immagine con larghezza e altezza di %s",
    imageUploadFailed: 'Caricamento immagine non riuscito',
    immediateRelease: 'Rilascio Immediato',
    immediateSend: 'Spedisci ora',
    imporFailedOfTableHeader: "Importazione non riuscita, l'intestazione del file non corrisponde.",
    import: 'importare',
    importDetails: 'Dettagli della domanda',
    importExcel: 'Importa EXCEL',
    importFail: 'Importazione fallita',
    importStatus: "Stato dell'importazione",
    importSuccessful: 'Importazione riuscita',
    importTemplate: 'Scarica modello',
    importer: 'importatore',
    importerAccountOperationRecord: 'Operazione account importatore e registro accessi',
    importerAvatar: "Avatar dell'importatore",
    importerDisplayName: "Nome visualizzato dell'importatore",
    importerEnquiry: "Richiesta dell'importatore",
    importerManagement: 'Gestione Importatori',
    importerOperationRecords: "Registri delle Operazioni dell'Importatore",
    importing: 'Importazione in corso...',
    inProcess: 'contromisure',
    inProgress: 'in corso',
    individualCenter: 'Centro individuale',
    informationCategory: 'Categoria di informazioni',
    informationCategoryList: 'Elenco delle categorie di informazioni',
    informationCategoryQuery: 'Interrogazione sulla categoria di informazioni',
    informationContent: 'Contenuto informativo',
    informationContentList: 'Elenco dei contenuti delle informazioni',
    informationCotnentQuery: 'Interrogazione del contenuto delle informazioni',
    informationCover: 'Copertura informativa',
    informationDetails: 'Informação Detalhes',
    informationImage: 'immagine di copertina',
    informationManagement: 'Gestione delle informazioni',
    informationTitle: "Titolo dell'informazione",
    informer: 'Segnalatore ',
    informerId: 'ID segnalatore ',
    initialPassword: 'Password iniziale',
    inputAgreementContent: "Inserisci il contenuto dell'accordo",
    inputCannotExceed20000: 'Puoi inserire al massimo 20000 caratteri',
    inputErrorEmoji: 'Non inserire emoticon',
    installDeviceYouCan: "L'installazione di questo dispositivo ti consente di",
    installVehicleModelAdd: 'Add Descrizione del modello di veicolo retromontato',
    installVehicleModelDescription: 'Descrizione del modello retromontato',
    installVehicleModelEdit: 'Modifica Descrizione del modello di veicolo retromontato',
    instrumentLastedVersion: "Il display TFT è già l'ultima versione",
    instrumentupgrade: 'Aggiornamento del display TFT',
    inteligentServiceReminder: 'Promemoria del servizio intelligente',
    intelligentInternetServiceIntroduction: 'Introduzione al servizio',
    intelligentServiceAgreement: 'Contratto di Servizio Intelligente',
    intelligentServices: 'Servizi intelligenti (dettagli del veicolo, dati di guida, OTA)',
    introText: {},
    introduction: 'Introduzione',
    invalidVercode: 'Codice di verifica non valido',
    invoicePreview: 'Anteprima fattura',
    invoicing: 'Fatturazione in corso',
    invoicingFailed: 'Fatturazione non riuscita',
    invoicingSucceeded: 'Fatturazione riuscita',
    iovNotice1: 'Le funzioni di cui sopra si basano sul dispositivo di rete del veicolo (T-Box), consultare il rivenditore locale per acquistare e installare',
    iovNotice2: 'Le funzioni di cui sopra sono diverse in base alla configurazione di ciascun modello e alla regione in cui si trova. Si prega di consultare il rivenditore locale per i dettagli.',
    iovNotice3: "Si prega di salvare e registrare in anticipo il numero del dispositivo, necessario per associare il dispositivo. Dopo aver completato l'associazione e l'installazione, puoi sperimentare più funzioni",
    isHelpful: 'Aiuta?',
    isStop: {},
    isSupportedChildOwnerOffMapDown: {},
    isSupportedNoOwnerOffMapDown: {},
    isSupportedOffMapDown: {},
    it_IT: 'Italiano',
    iterativeVehicleFunctions: 'Le parti principali del veicolo possono essere aggiornate online da remoto per iterare continuamente le funzioni del veicolo',
    jumpSettings: 'Salta le impostazioni',
    jumpTarget: {},
    jumpToWeb: {},
    jumpUrl: {},
    justNow: 'Solo ora',
    keySharing: 'Chiave digitale e condivisione delle chiavi',
    kolUser: 'Utente KOL',
    kolUserList: 'Elenco degli utenti KOL',
    kolUserManagement: 'Gestione degli utenti KOL',
    kolUserQuery: "Query dell'utente KOL",
    language: 'Lingua',
    language1: 'Lingua associata',
    languages: 'linguaggio',
    lastLoginTime: "Ora dell'ultimo accesso",
    lastModifiedBy: 'Ultima modifica effettuata da',
    lastUpdateTime: "Ora dell'ultimo aggiornamento",
    latitude: 'Latitudine',
    launchActivity: 'Lancia attività  ',
    likeNumber: 'Numero di "Mi Piace"',
    linkAddress: {},
    linkUrlDescription: {},
    linkedOrder: 'Ordine collegato',
    listDisplayImages: "Visualizzazione dell'elenco",
    listOfImporters: 'Elenco degli importatori',
    listOfQuestion: {},
    listShowStoreCoverPic: "Mostra l'immagine di copertina del negozio",
    loadMore: 'Carica di più',
    loadSuccess: 'Caricamento completato',
    loading: 'Caricamento',
    locationFail: {},
    log: 'Registro',
    login: 'Log in',
    loginCountry: 'Paese/regione di accesso',
    loginSuccessfully: 'Accesso riuscito',
    logout: 'Esci Stato di accesso',
    longitude: 'Longitudine',
    loosing: 'Aggiornamento dei dati...',
    lowCompatibleVersion: 'Versione minima compatibile',
    mail: 'E-mail',
    male: 'Maschio',
    manualReviewStatus: 'Stato della revisione manuale',
    mapManage: {},
    marketDataOfdealerStores: 'Dati di mercato dei negozi concessionari',
    masteringCyclingData: 'Dati di guida master',
    maximum: 'Massimo',
    maximumBannerCountTip: 'Possono essere online al massimo %s banner contemporaneamente,  rimuovi almeno uno prima.',
    maximumMileage: 'Chilometraggio massimo riscattabile',
    maximumValue: 'Massimo',
    menuFunctionName: 'Nome funzione menu',
    menuIcon: 'Icone menu',
    messagePush: 'Messaggio push',
    messagePushDeleteAsk: 'Sei sicuro di cancellare questo push?',
    messagePushDownloadTemplate: 'Scarica prima il modello, poi compia il file e carica il file modello. La dimensione del file è limitata a 2M. Riduci il contenuto in modo appropriato in caso di invio non riuscito.',
    messageWithdrawAsk: 'Vuoi ritirare questo push?',
    middle: 'mezzo',
    min: 'Minuti',
    minAgo: '%s min fa',
    minimum: 'Minimo',
    minimumValue: 'Minimo',
    modelDetail: 'Dettagli del modello',
    modifyFail: 'Modifica non riuscita',
    modifyPassword: 'Modifica password',
    modifySuccess: 'Modifica riuscita',
    monday: 'Lunedì',
    more4pic1video: 'Massimo 4 immagini / 1 video',
    moreDetailsConsultDealerStore: 'Per ulteriori dettagli, si prega di consultare il rivenditore.',
    morning: 'Mattina',
    motoPlay: 'MotoPlay (servizio di navigazione e proiezione basato su Google)',
    motoPlayAgreement: "Stato dell'accordo MotoPlay",
    motoplatNavigationScreen: 'Proiezione della navigazione MotoPlay',
    motoplayServicePay: 'Pagamento per MotoPlay',
    motoplayServiceResetTimeRule: "L'ora di ripristino di MotoPlay non può essere successiva all'ora corrente.",
    motorcycle: 'due ruote',
    moveDown: 'Sposta verso il basso',
    moveLongPressMap: {},
    moveMapSelectPoint: {},
    moveTo: 'Sposta verso',
    moveToBottom: 'Sposta in basso',
    moveToTop: 'Sposta in alto',
    moveToTopStatus: 'Bloccato in alto',
    moveTop: 'Fissa in alto',
    moveUp: "Sposta verso l'alto",
    multimedia: 'Multimedia',
    mustInteger: {},
    mute1Day: 'Bannato per 1 giorno',
    mute2Days: 'Bannato per 2 giorni',
    mute30Days: 'Bannato per 30 giorni',
    mute3Days: 'Bannato per 3 giorni',
    mute7Days: 'Bannato per 7 giorni',
    muting: 'In stato bannato',
    nameOfImporter: "Nome dell'importatore",
    navigation: 'Navigazione su mappa',
    nearLoginTime: "Ora dell'ultimo accesso",
    needPopup: 'È necessaria una finestra pop-up',
    negativeNum: 'Recensione negativa',
    networkException: 'Eccezione di rete',
    newAddFail: 'Aggiunta non riuscita',
    newAddSuccess: 'aggiunto con successo',
    newBanner: 'Nuovo Banner',
    newCancellationAgreement: 'Nuove condizioni di cancellazione',
    newEmail: 'Nuova e-mail',
    newEmailEqualsValidate: 'La nuova posta elettronica non può essere uguale a quella originale',
    newFunctionIntro: {},
    newMenuFunction: 'Nuova funzione menu',
    newModelSeries: 'Nuova serie di modelli',
    newPassword: 'Nuova password',
    newPasswordNotEqual: 'La nuova password inserita due volte non è coerente, reinserirla',
    newQuestionType: {},
    newStoreNumber: 'Numero di nuovi negozi',
    newTopic: 'Nuovo argomento',
    newUnbindingCommitment: {},
    nextStep: 'Avanti',
    nickName: 'Soprannome',
    no: 'No',
    noContent: 'Nessun contenuto correlato',
    noContent2: 'Suggerisci di cambiare le parole chiave o',
    noData: 'Nessun dato',
    noExchangeRecord: 'Nessun record di riscatto ancora',
    noFeedbackRecord: 'Al momento non ci sono registrazioni di feedback.',
    noJump: 'Nessun salto',
    noLog: 'Nessun registro',
    noMores: 'Non di più',
    noNeedPopup: 'Nessun popup richiesto',
    noOkToFeedback: 'Irrisolto, voglio dare un feedback',
    noOwnerScore: 'Valutazioni di non proprietario',
    noPass: 'Rifiuta',
    noSendPeople: 'Nessun mittente',
    noSortingPermission: 'Nessuna autorizzazione di ordinamento',
    noSupportMapDown: {},
    noThisPermission: 'Nessun permesso per questa operazione',
    noUserSelected: 'Nessun utente selezionato, impossibile inviare',
    nofiledSeviceContent: {},
    nonOwner: 'Non proprietario',
    nonVehicleOwnerCharged: {},
    none: 'Nessuno',
    normal: 'Normale',
    notAllowImageAndVideo: 'Non è possibile selezionare il video quando si selezionano le immagini',
    notAllowed: 'Non consentito',
    notBeLessOrEqual: 'Non deve essere inferiore o uguale a',
    notDeleted: 'Non cancellato',
    notDistributedYet: 'Non emesso',
    notEnabled: 'Non abilitato',
    notHelpful: {},
    notLessThan: 'Non deve essere inferiore a',
    notRecommended: 'Non consigliato',
    notReleasedYet: 'Non ancora pubblicato',
    notStarted: {},
    'notSupportT-Box': 'Mi dispiace, il tuo veicolo non supporta T-Box.',
    notTop: 'Non fissare in alto',
    notice: 'Avviso',
    noticeText1: 'Dear CFMOTO users,',
    noticeText2:
      'Hello! We sincerely thank you for your continuous support and trust in CFMOTO. In order to continuously improve your service experience, we are committed to enhancing service quality and implementing innovative improvements. In this context, we have made business adjustments and hereby notify you that as of 08/10/2024, we will discontinue the CFMOTO RIDE App (the "App") in the United States. In order to ensure that your service experience is not affected, we have launched a brand-new CFMOTO RIDESYNC App. We hope you can continue to enjoy our new services through this new app.',
    noticeText3: 'Important notes:',
    noticeText4: '1. From today on, this app will only be available for bound CFMOTO vehicles in the United States and no longer support binding new vehicles. If you need to bind a new vehicle, please download and use the CFMOTO RIDESYNC App.',
    noticeText5:
      '2. We strongly recommend that you download and use the CFMOTO RIDESYNC App before 08/10/2024 so that you can continue enjoying our services seamlessly. We provide you with a convenient data migration service. You can choose to migrate all data retained in this App to the CFMOTO RIDESYNC App to preserve your personal information, vehicle information and past service records. We will ensure your data security and privacy during the migration process. If you want to use the CFMOTO RIDESYNC App without migrating data, you can re-register with the CFMOTO RIDESYNC App to use the new services. Click on the button below to learn how to download and use the CFMOTO RIDESYNC App.',
    noticeText6:
      '3. Please note that after 08/10/2024, you will no longer be able to use the relevant services of the App in the United States. Meanwhile, we will delete all personal data generated during your use of the App according to the relevant laws and regulations.',
    noticeText7:
      'We are fully aware that this change may cause temporary inconvenience to you, but we believe that with this service upgrade, you will have a richer and more satisfying user experience. If you encounter any issues or have questions during this process, we will always be here to help. Thank you for your understanding and cooperation, and we look forward to serving you in the CFMOTO RIDESYNC App.',
    noticeText8: 'Wish you a happy life!',
    notzero: 'I numeri di versione non possono essere tutti 0',
    obtainVerificationCode: 'Ottenere il codice di verifica',
    officiaAndKolList: 'Elenco ufficiale/KOL',
    officialAccount: 'Account ufficiale',
    officialAccountAuth: 'Autenticazione account ufficiale',
    officialIrKOLSearch: 'Ricerca Ufficiale/KOL',
    officialKolAuth: 'Autenticazione ufficiale/KOL',
    offline: 'Offline',
    offlineAlready: 'Offline',
    offlineTime: 'Ora offline',
    offlineTimeMustBeGreaterThan: "L'ora offline deve essere successiva a",
    ok: 'OK',
    oldPassword: 'Vecchia password',
    onLineAlready: {},
    oneMonths: 'Un mese',
    oneYear: 'Un anno',
    online: 'Online',
    onlyFourWheel: 'Solo a quattro ruote',
    onlyTwoWheel: 'Solo due ruote',
    openEveryCount: {},
    openEveryDay: {},
    openProductType: {},
    operationRecord: 'Cronologia di operazioni',
    operationTime: 'Ora di operazione',
    operations: 'Operazioni',
    operator: 'Operatore',
    operattor: 'Operatore',
    opreate: {},
    opreateFunSet: {},
    opreateFunSetAdvert: {},
    opreateFunSetAdvertAdd: {},
    opreateFunSetAdvertEdit: {},
    opreateFunSetAdvertView: {},
    optionalUpgrade: 'Aggiornamento facoltativo',
    orderFeedBackNum: 'Numero di feedback sugli ordini',
    orderList: {},
    orderMange: {},
    orderNum: {},
    orderQuestion: "Descrivi l'ora di occorrenza e dettagli del problema, quindi carica uno o più screenshot del problema. Per problemi di pagamento, carica anche il registro di addebito.",
    originalEmail: 'E-mail originale',
    otaUpgradeVehicle: 'Veicolo di aggiornamento OTA',
    otaUpgradeVehicleDesc: 'I componenti principali del veicolo possono essere aggiornati da remoto per ripetere continuamente le prestazioni del veicolo.',
    other: 'Altro',
    over: 'Sopra',
    owner: "C'è una macchina",
    ownerIdHomepageImage: "Pagina principale della carta d'identità, patente di guida o passaporto contenente informazioni personali di identificazione.",
    parameterConfiguration: 'Configurazione dei parametri',
    partialImportFailed: 'Importazione parziale fallita',
    pass: 'Approva',
    passValidateDeleteAccount: "Verifica dell'identità riuscita! Clicca sul pulsante Invia richiesta in basso per richiedere l'eliminazione dell'account",
    password: 'Password',
    passwordRuleText: '8-20 caratteri, devono contenere lettere inglesi maiuscole e minuscole, numeri, caratteri speciali',
    passwordRules: 'Regole password',
    paySetting: {},
    payStrategy: {},
    paymentLastDayBasedata: 'Durata a pagamento della edizione standard',
    paymentLastDayMotoplay: 'Durata a pagamento MotoPlay',
    peleaseEnterProvince: 'Inserire una provincia/stato',
    pendSend: 'In attesa di',
    pending: 'In attesa.',
    pendingSubmit: 'Invio In Attesa',
    permanentMuting: 'bannato permanentemente',
    phoneModel: 'Modello',
    phoneNum: 'numero di telefono',
    phoneNumber: 'Numero di telefono',
    phoneOrEmail: 'Numero di telefono/E-mail',
    phoneOrEmailImportTemplate: 'Modello di importazione di numero di cellulare/indirizzo e-mail',
    phoneOrEmailNotRegistered: 'Questo numero di cellulare o indirizzo e-mail non è registrato',
    phoneOrEmailOrUserId: 'Numero di cellulare/indirizzo e-mail/ID utente',
    picture: 'Immagine',
    pl_PL: 'Polacco',
    pleaseAddImage: 'Aggiungi file di immagine',
    pleaseAddVideoFile: 'Per favore aggiungi file video',
    pleaseEnter: 'Si prega di inserire',
    pleaseEnterAccountInfo: "Inserisci le informazioni sull'account",
    pleaseEnterAmount: {},
    pleaseEnterCity: 'Inserire una città',
    pleaseEnterEmail: 'Inserisci il tuo indirizzo email',
    pleaseEnterEmailAdress: 'Inserire l’indirizzo email',
    pleaseEnterIntro: "Inserisci l'introduzione",
    pleaseEnterLatAndLong: 'Inserire latitudine e longitudine',
    pleaseEnterNewPassword: 'Inserisci la nuova password',
    pleaseEnterPassword: 'Inserire la password',
    pleaseEnterPhone: 'Per favore immetti il ​​tuo numero di telefono',
    pleaseEnterQuestionDescription: 'Inserire una descrizione del problema',
    pleaseEnterRealname: 'Inserisci il tuo vero nome',
    pleaseEnterRemark: 'Inserisci commenti',
    pleaseEnterServePhone: "Inserire il numero di telefono dell'assistenza",
    pleaseEnterStoreAddressDetail: "Inserire l'indirizzo dettagliato",
    pleaseEnterStoreIntroduce: "Inserire l'introduzione del negozio",
    pleaseEnterStoreName: 'Inserire il nome del negozio',
    pleaseEnterStoreRemarkName: "Inserire il nome dell'osservazione del negozio",
    pleaseEnterTitle: 'Inserisci un titolo',
    pleaseEnterUsername: 'digitare un nome utente',
    pleaseEnterVercode: 'Inserire il codice di verifica',
    pleaseEnterVersion: 'Inserisci il numero di versione',
    pleaseEnterVersionIntroduction: "Inserisci l'introduzione della versione",
    pleaseEnterVideoDetail: 'Inserisci i dettagli del video',
    pleaseEnterVin: 'Si prega di inserire il VIN',
    pleaseInputWord: 'Si prega inserire la parola chiave',
    pleaseLoginFirst: "Si prega effettuare prima l'accesso",
    pleaseRepeatNewPassword: 'si prega di ripetere la nuova password',
    pleaseSelect: 'si prega di scegliere',
    pleaseSelectAuthAccount: 'Seleziona account da autenticare',
    pleaseSelectBusinessHours: 'Selezionare gli orari di apertura',
    pleaseSelectCity: 'Si prega di selezionare la città',
    pleaseSelectCountry: 'Si prega di selezionare il paese',
    pleaseSelectCurrency: {},
    pleaseSelectMatchingMultimediaContent: 'Seleziona il contenuto multimediale corrispondente',
    pleaseSelectPayChannel: {},
    pleaseSelectProblemWhere: 'Selezionare uno scenario in cui si verifica il problema',
    pleaseSelectProducType: {},
    pleaseSelectProvince: 'Si prega di selezionare la provincia/lo stato',
    pleaseSelectQueType: 'Selezionare il tipo di domanda',
    pleaseSelectReportReason: 'Selezionare il motivo della segnalazione',
    pleaseSelectService: 'Seleziona prima un servizio',
    pleaseSelectStatus: 'Selezionare lo stato',
    pleaseSelectStoreType: 'Selezionare il tipo di negozio',
    pleaseSelectTimedSendTime: "Seleziona l'orario di invio",
    pleaseSelectUserTheList: "Seleziona un utente dall'elenco",
    pleaseSelectVehicle: 'Seleziona un veicolo',
    pleaseSelectVehicleConfig: {},
    pleaseSelectlinkedOrder: 'Si prega di selezionare un ordine collegato.',
    pleaseSelectupgradeType: 'Seleziona il metodo di aggiornamento',
    pleaseSureType2: 'Assicurati che tutto in',
    pleaseUpload: 'Carica',
    pleaseUploadPicVideo: 'Caricare immagini/video',
    pleaseUserTimeFill: "Compila in base all'orario dell'utente finale",
    popUpFrequencyType: 'Modulo della finestra pop-up',
    popUpFrequencyValue: 'Frequenza dei pop-up',
    popUpFrequencyValueValid: 'Seleziona i giorni di frequenza',
    popUpReminder: 'Se visualizzare un promemoria',
    popupArea: 'intervallo utente pop-up',
    popupCreate: {},
    popupDayOne: 'Una volta per numero di giorni prestabilito',
    popupEdit: {},
    popupFrequency: {},
    popupManagement: {},
    popupOne: {},
    popupPosition: {},
    popupStatus: {},
    popupTarget: {},
    popupTime: {},
    popupTitle: {},
    positiveNum: 'Buone recensioni',
    postComment: 'Commento al post',
    postContent: 'Contenuto post',
    postId: 'ID post',
    postList: 'Elenco post',
    postManagement: 'Gestione di post',
    postSearch: 'Ricerca di contenuto',
    posts: 'Post',
    precautionText1:
      'Hello! As you have learned that we will discontinue the CFMOTO RIDE App (hereinafter referred to as "the App") in the United States from 08/10/2024, to assist you with this change, please take note of the following important matters:',
    precautionText2: '1. From today on, you will not be able to bind a new vehicle through the APP to enjoy relevant vehicle services.',
    precautionText3: '2. To ensure a smooth transition to the new service, we have provided an entry at the top of the vehicle page in this App. You can learn how to download and use the CFMOTO RIDESYNC App at any time through that entry.',
    precautionText4:
      '3. Please note that once the service ceases to take effect, you will no longer be able to enjoy any services of the App in the United States. At the same time, we will delete all personal data generated during your use of the App in accordance with relevant laws and regulations. This means that we will not be able to respond to any of your requests for data after the service is discontinued.',
    precautionText5:
      'We understand that this change may cause inconvenience to you, but we are committed to continuously protecting your data security and privacy. We encourage you to take early action to download and start using the CFMOTO RIDESYNC App in a timely manner so that you can continue to enjoy the quality service provided by CFMOTO. If you have any questions or need assistance in this process, please do not hesitate to contact us. We look forward to serving you in the CFMOTO RIDESYNC App.',
    privacyContent: 'Dettagli del contenuto della politica sulla privacy',
    privacyPolicy: 'Politica della privacy',
    privacyPopupAgree: "Ottieni nuovamente il consenso dell'utente alla politica sulla privacy tramite una finestra pop-up",
    privacyVersion: "Versione dell'informativa sulla privacy",
    privacyVersionList: 'Elenco delle versioni della politica sulla privacy',
    problemaDes: 'Descrizione del problema',
    processMethod: 'Metodi di gestione',
    processReason: 'Motivo di gestione',
    processReasonDetails: 'Dettagli motivo gestione',
    processRecord: 'Cronologia di gestioni',
    processReport: 'Gestisci segnalazioni',
    processSolution: 'Soluzione di gestione',
    processUser: 'Gestisci utente  ',
    processed: 'Procedimento',
    productDetails: {},
    productTime: 'tempi di produzione',
    prohibitDecimalsAndNegative: {},
    pt_PT: 'portoghese',
    publishInformation: 'Pubblicare informazioni',
    publishPosts: 'Pubblica post',
    pullBefore: 'Tirare giù per rinfrescare.',
    pulling: 'Rilasciare aggiornamento ora',
    purchaseAndInstall: 'Acquista e installa',
    pushConfiguration: 'Configurazione push',
    pushContent: 'Spingi il contenuto',
    pushList: 'Elenco di push',
    pushMode: 'Modalità di push',
    pushNow: 'Esegui push ora',
    pushQuery: 'Ricerca push',
    pushRecord: 'Cronologia di push',
    pushScope: 'Campo di push',
    pushTime: 'Ora di push',
    pushTimeDifferenceAsk: "L'orario di invio scelto potrebbe impedire ad alcuni utenti di ricevere questo push a causa delle differenze di orario. Sei sicuro di voler salvare?",
    pushTitle: 'Titolo di push',
    pushed: 'Spinto',
    pushing: 'Push in corso',
    quantity: 'Quantità',
    query: 'Ricerca',
    question: {},
    questionInquiry: {},
    questionType: 'Tipo di domanda',
    questionTypeList: {},
    questionTypeTemplate: {},
    quickRelease: 'Pubblicazione rapida',
    ranking: 'Classifica',
    ratingWarn1:
      'Per gli utenti proprietari di veicoli, il controllo dei servizi intelligenti corrispondente al paese/regione in background di gestione non è stato attivato o il servizio dei servizi intelligenti non è scaduto dopo essere stato attivato. Il veicolo è online e ha',
    ratingWarn2: "o più record di guida completi (l'inizio e la fine di ogni corsa vengono segnalati), verrà visualizzato un pop-up quando l'utente esce da My Cycling e torna alla home page.",
    reUpgrade: 'Riprova',
    readAgree: 'Leggi e accetta la',
    readAndAgree: 'Leggere e accettare',
    readAndAgreeTo: 'Ho letto e accettato la',
    readDeleteStep: 'comprendere i tipi di dati che elimineremo o conserveremo e gli eventuali periodi di conservazione aggiuntivi',
    realname: 'Vero nome',
    reasonForReport: 'Motivo',
    receiveCarReminderMessage: 'Ricezione avvisi messaggio veicolo',
    rechargeAmount: {},
    rechargeChannel: {},
    rechargeStatus: {},
    rechargeTime: {},
    recharged: {},
    recipients: 'Destinatario',
    recipientsNum: 'Ambito destinatario',
    recommended: 'Consigliato ',
    recommendedStatus: 'Stato consigliato',
    redeemableServiceHours: 'Ore di servizio riscattabili',
    redemptionMileage: 'Chilometraggio riscattabile',
    redemptionRatio: 'Rapporto di riscatto',
    redemptionTime: 'Tempo di riscatto',
    redirectUrl: {},
    refreshInterval: 'Tempo di aggiornamento',
    refreshSend: 'inviare nuovamente',
    refundFailed: {},
    refunded: {},
    refunding: {},
    refused: 'Respinto',
    registerDate: 'Data di registrazione',
    rejected: 'Rifiutato.',
    releaseContent: 'Pubblica contenuto  ',
    releaseMethod: 'Metodo di pubblicazione',
    releaseMute: 'Sbanna',
    releaseTime: 'Tempo di rilascio:',
    released: 'Pubblicato',
    releasedBy: 'Pubblicato da',
    remainServiceHavExpired: 'Tempo rimanente fino alla scadenza del servizio intelligente',
    remainingAvailableMileage: 'Chilometraggio disponibile rimanente',
    remark: 'Note',
    rememberPassword: 'Ricorda la password',
    reminder: 'Promemoria',
    remove: 'Rimuovi',
    removeOnlinUpgrade: 'Veicolo di aggiornamento online remoto',
    repeatNewPassword: 'Ripeti la nuova password',
    replaceTBOX: 'Sostituisci TBOX',
    replied: 'Risposte',
    reply: 'Rispondi',
    report: 'Segnala',
    reportList: 'Lista di segnalazioni',
    reportManagement: 'Gestione segnalazioni',
    reportReason: 'Motivo segnalazione',
    reportReasonDetails: 'Dettagli motivo segnalazione',
    reportReasonPlaceholder: 'Scrivere ciò che si vuole riferire, 0-1500 parole',
    reportSearch: 'Ricerca di segnalazione',
    reportSuccessful: 'Segnalazione riuscita, ce ne occuperemo il prima possibile',
    reportTime: 'Ora di segnalazione',
    reportType: 'Tipo di relazione',
    reportedContent: 'Contenuto segnalato',
    reportedUser: 'Utente segnalato',
    reportedUserId: 'ID utente segnalato',
    requestTimedOut: 'Tempo scaduto per la richiesta',
    resend: 'Rinvia',
    resendTo: 'Inviare nuovamente a',
    reset: 'Ripristina',
    resetItem: 'Voce da reimpostare',
    resetTime: 'Ora di ripristino del servizio intelligente',
    resetWarn: "Dopo il ripristino, la durata gratuita dei servizi intelligenti del veicolo verrà ricalcolata e avrà effetto in base all'ora corrente (ora del browser). Si prega di confermare se si desidera ripristinare.",
    return: 'Ritorno',
    review: 'Revisiona',
    reviewApproved: 'Revisione superata',
    richText: {},
    ro_RO: 'rumeno',
    roleDescription: 'Espressione di ruolo',
    roleName: 'Nome ruolo',
    rolePermission: 'Permesso ruolo',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: 'ebook',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: 'russo',
    safeRemind: 'Per proteggere la sicurezza del proprio account, si prega di non inserire qui informazioni personali sensibili, come password di account, ecc.',
    satelliteMap: 'Mappa satellitare',
    saturday: 'Sabato',
    save: 'Salva',
    saveAndPreview: "Salva e visualizza l'anteprima",
    saveAsDraft: 'Salva come bozza',
    saveFail: 'Salvataggio fallito',
    savePicture: 'Salva immagine',
    saveSettings: 'Salva le impostazioni',
    saveSuccess: 'Salvataggio riuscito',
    saveVideo: 'Salva video',
    scanQrcodePreview: "Scansiona il codice QR qui sotto con il tuo cellulare per visualizzare l'anteprima",
    screenNavigationGuidance: 'Impostare Istruzioni',
    sdkStatement: 'Dichiarazioni SDK',
    search: 'Cerca',
    searchRecords: 'Ricerche storiche',
    secondaryMenu: 'meMenunu secondario',
    securityMessage: "Le informazioni sopra riportate sono utilizzate esclusivamente per la verifica dell'identità; CFMOTO tutela le tue informazioni.",
    securityServices: 'Servizi di sicurezza (posizionamento in tempo reale, geo-fence, allarme di malfunzionamento)',
    select: 'Scegli',
    selectAccount: 'Seleziona account',
    selectAll: 'Selezionare tutti',
    selectAuthentication: "Seleziona l'autenticazione",
    selectChannelType: 'Seleziona un canale di feedback',
    selectCountry: 'Selezionare il paese',
    selectData: 'Si prega di selezionare i dati che desideri eliminare, e cliccare sul pulsante Invia in basso per inviare la tua richiesta di eliminazione dei dati.',
    selectDate: 'Seleziona Data',
    selectEnableStatus: {},
    selectFeedBackState: 'Seleziona lo stato di elaborazione del feedback',
    selectFeedbackType: 'Seleziona un tipo di feedback',
    selectJumpTarget: {},
    selectLanguage: 'Si prega di selezionare la lingua',
    selectOneCarType: 'Seleziona almeno un modello',
    selectPoint: {},
    selectPopupFrequency: {},
    selectPopupPosition: {},
    selectPopupTarget: {},
    selectPopupTime: {},
    selectRejectReason: 'Seleziona un motivo per il rifiuto',
    selectTheLanguage: 'Seleziona la lingua',
    selectTime: "seleziona l'ora",
    selectUser: 'Seleziona gli utenti',
    selectVehicle: 'Seleziona il veicolo',
    selectedMileage: 'Chilometraggio selezionato',
    selectedMileageRedemption: 'Seleziona il chilometraggio per riscatto',
    selectionOfImporter: "Selezione dell'importatore",
    sendNumberDescription: 'numero di dispositivi validi per cui AWS Cloud ha creato task di invio;',
    sendNumberDescription0: "Il numero dei dispositivi, tra i dispositivi di destinazione validi, su cui il server Aurora crea effettivamente con successo l'attività di invio.",
    sendNumberVolume: 'Numero di invii',
    sendTo: 'Inviare a',
    sendType: 'Modalità di invio',
    sendUserNum: 'Numero di invii',
    sending: "Nell'invio",
    serial: 'No.',
    seriesBackground: {},
    seriesDesc: {},
    seriesIntroduction: 'Introduzione della serie',
    seriesName: {},
    seriesShowcase: 'Vetrina di serie',
    seriesUplodImgRule: {},
    seriousAlarm: 'Allarme grave',
    serviceDays: 'Giorni di servizio',
    serviceDetail: 'Dettagli del servizio intelligente',
    serviceExpiration: 'I tuoi servizi intelligenti sono scaduti',
    serviceHavExpired: 'I servizi intelligenti sono scaduti',
    serviceIntroduction: 'Introduzione al servizio',
    serviceReset: 'Reset del servizio intelligente',
    serviceText: 'Servizio',
    settingSuccess: 'Impostato con successo',
    shareNumber: 'Numero di condivisioni',
    sheet: 'Zhang',
    show: 'Vista',
    showPicturesOfVideos: 'Mostra foto/video',
    showToast1: 'Il chilometraggio rimanente non è sufficiente per riscattare 1 giorno di servizio',
    showToast2: 'Per il riscatto è necessario almeno 1 giorno di servizio',
    showToast3: 'Il parametro non esiste o è nullo',
    showroomModel: 'Modelli di showroom',
    showroomModelList: 'Elenco modelli da showroom',
    showroomModelQuery: 'Richiesta modello da showroom',
    showroomUploadRules: 'Il requisito del formato immagine è jpg/jpeg/png, il rapporto immagine è 9:19,5, la dimensione non supera 5 MB e la dimensione video non supera 50 MB',
    signOut: 'Terminazione automatica',
    singapore: 'Singapore',
    sixMonths: 'Sei mesi',
    slideToRight: 'scorri verso destra',
    smartServices: 'Servizi intelligenti',
    someUser: 'Alcuni utenti',
    sort: 'Sorta',
    source: 'Fonte',
    sr_YU: 'serbo',
    standardAgreement: "Stato dell'accordo Standard Edition",
    startCalculateTimeBasedata: 'Tempo di reset edizione standard',
    startCalculateTimeMotoplay: 'Tempo di reset di MotoPlay',
    startChecking: 'Avvia controllo',
    startTime: 'Ora di inizio',
    statisticalTime: 'Tempo statistico',
    status: 'Stato',
    stepText1: 'To ensure smooth data migration and use of the CFMOTO RIDESYNC App, we recommend that you follow these steps:',
    stepText2: '1. First, you can click the button below [Download CFMOTO RIDESYNC] or directly open Apple Store/Google Play to search and download CFMOTO RIDESYNC App;',
    stepText3: '2. After downloading and installing, please open the CFMOTO RIDESYNC App to enter the login page. On this page, you need to log in with your existing CFMOTO RIDE account and password;',
    stepText4:
      '3. When you enter your account and password correctly, the App will pop up a prompt window asking whether to start the data migration. When you click OK, the data migration starts immediately and this process is uninterrupted. If you select "Cancel" in this step, you will not be able to continue logging into the App.',
    stepText5: '4. After clicking OK, the data migration will start immediately, and the process is uninterruptable. If that fails, contact it@cfmoto.com',
    stepText6:
      '5. After the data migration is completed, you will automatically enter the vehicle homepage of the CFMOTO RIDESYNC App. At this moment, you can start to use all functions of the App normally, and you will be able to access all the data you previously retained in the CFMOTO RIDE App.',
    stepText7:
      '*Important notes: Be sure to log in the CFMOTO RIDESYNC App with your CFMOTO RIDE account to ensure successful data migration. If you choose to register a new account or log in with another account, your data will not be migrated. In addition, after successful data migration, your original CFMOTO RIDE account will no longer support login to the CFMOTO RIDE App. Please operate carefully to ensure the safe migration of your data.',
    stop: {},
    store: {},
    storeAddressCountryTip: "Nota: Questo indirizzo del negozio è l'unica base per farsi trovare dagli utenti. Si prega di compilare attentamente per assicurarsi che l'indirizzo sia corretto",
    storeAddressDetail: 'Indirizzo del negozio',
    storeAddressDetailTip: 'Esempio: indirizzo dettagliato:  NO.116, Wuzhou Road, Yuhang Economic Development Zone, Hangzhou',
    storeAddressPosition: 'Latitudine e longitudine',
    storeAddressPositionTip:
      'Longitudine: la parte intera della longitudine è un numero intero da -180 a 180 e la parte decimale è un decimale non superiore a 15 cifre.\nLatitudine: la parte intera della latitudine è un numero intero da -90 a 90 e la parte decimale non supera le 15 cifre decimali.',
    storeBusinessType: 'Tipo di negozio',
    storeImage: 'Immagine del negozio',
    storeImportTemplateText:
      'Scaricare il modello, compilare le informazioni sul negozio del rivenditore nel file modello e quindi caricare il file; la dimensione del file è limitata a 1 MB; in caso di errore di invio, ridurre il contenuto o caricare a lotti',
    storeIntroduce: 'Introduzione al negozio',
    storeList: 'Elenco dei negozi',
    storeMange: 'Gestione del negozio',
    storeName: 'Nome del negozio',
    storeNameTip: 'Nota: Selezionare una lingua supportata dal sistema per inserire il nome del negozio',
    storeQueryUserStatistics: 'Statistiche delle query utente di negozio',
    storeRemarkName: "Nome dell'osservazione del negozio",
    storeRemarkNameTip: "Nota: Se la lingua supportata dal sistema non soddisfa le esigenze dell'utente, è possibile inserire qui il nome dell'osservazione del negozio nella lingua desiderata.",
    storeSearch: 'Query dei negozi',
    storeServicePhone: 'Numero di telefono del servizio',
    storeServicePhoneTip: 'Nota: Questo numero viene utilizzato per il contatto telefonico con i clienti, assicurarsi che il numero di telefono sia corretto.',
    storeServiceTime: 'Orario di apertura',
    storeStatistics: 'Statistiche del negozio',
    storeUploadImageRequire:
      "Requisiti di formato dell'immagine per jpg/jpeg/png, si raccomanda che la dimensione di una singola immagine non superi i 5MB, una singola importazione fino a 9, può essere importata più di una volta, il numero totale di non più di 9",
    storefront: 'Negozio',
    submissionFailed: 'Invio fallito, per favore riprova.',
    submit: 'Invia',
    submitAccountDeleteApply: "Invia la richiesta di eliminazione dell'account",
    submitDataDeleteApply: 'Invia la richiesta di eliminazione dei dati',
    submitFeedback: 'Invia feedback',
    submitForReview: 'Invia per revisione',
    submitted: 'Presentato',
    successful: 'Riuscito',
    sunday: 'Domenica',
    supportMapDown: {},
    supportedChannel: {},
    sureAgree: 'Accettare o no?',
    sureBackApply: "Conferma il ritiro della richiesta di cancellazione dell'account",
    sureDelete: 'Una volta eliminato, non può essere recuperato. Sei sicuro di voler cancellare',
    sureDeleteData: 'Sei sicuro di voler eliminare i dati selezionati? Una volta confermata, i dati vengono eliminati immediatamente e non possono essere recuperati',
    sureDeleteSeries: {},
    sureDeleteSetting: {},
    sureDeleteStoreInfo: "Confermare l'eliminazione delle informazioni del negozio? Dopo l'eliminazione, le informazioni non saranno recuperabili",
    sureReject: 'Sei sicuro di rifiutare?',
    sureSuspend: "L'invio verrà interrotto al termine. Sei sicuro di voler terminare",
    suspend: 'Terminare',
    sv_SE: 'svedese',
    switchLanguage: 'Cambia lingua',
    system: 'Sistema',
    systemBusy: 'Il sistema è occupato, riprova più tardi',
    systemVersion: 'versione del sistema',
    tboxInstall: 'Tbox post-installazione',
    tboxIntro: 'T-Box è il dispositivo chiave per realizzare la funzione di connessione di rete intelligente dei veicoli',
    teamConfigTip: {},
    threeMonths: 'Tre mesi',
    thursday: 'Giovedì',
    time: 'Ora',
    timeSend: 'Invio temporizzato',
    timedOffline: 'Offline programmato',
    timedPush: 'Push programmato',
    timedRelease: 'Pubblicazione programmata',
    timedSendTime: "Invia l'ora",
    tips: 'Consigli',
    title: 'titolo',
    to: 'A',
    toBeReleased: 'Da pubblicare',
    topMenu: 'Menu di livello superiore',
    topicContent: 'Contenuto argomento',
    topicList: 'Elenco argomenti',
    topicManagement: 'Gestione argomenti',
    topicSearch: 'Ricerca di argomento',
    topicTitle: 'Titolo argomento',
    totalAndlLayoutOfStores: 'Numero totale e layout dei negozi',
    totalClicks: {},
    totalNumber: 'Tempi totali',
    tr_TR: 'Turco',
    triggerNum: 'Numero di trigger',
    tuesday: 'Martedì',
    turnOn: 'Aprire',
    twoCarAndFourCarOfNumber: 'Numero di utenti di veicoli a due e quattro ruote',
    twoCarOfNumber: 'Numero di utenti di veicoli a due ruote',
    twoWheelConfig: {},
    twoWheeler: 'Due ruote',
    twoWheelerAndFourWheeler: 'Veicoli a due e quattro ruote',
    twoWheelerMostClicks: 'I modelli di due ruote con il maggior numero di clic',
    twoWheelowner: {},
    type: 'Tipo',
    typeMessage: 'tipo di feedback',
    types: 'Tipo',
    unbind: 'Dissociato',
    unbindingCommitment: {},
    unbindingLabelRealName: 'Nome e cognome',
    unbound: 'Scollegato.',
    understandRealtimeConditions: "Ricevi le vibrazioni del veicolo e i messaggi di promemoria per l'ingresso e l'uscita del veicolo dalla recinzione elettronica e comprendi lo stato del veicolo in tempo reale",
    uninstallTboxDesc: "Per i veicoli su cui non è installata una T-Box, è possibile visualizzare le informazioni di base del veicolo come il numero di telaio, il numero del motore e il manuale elettronico dopo l'associazione.",
    unitCurrencyPer: {},
    unitMonth: 'Mese',
    unlimited: 'Illimitato',
    unpaid: {},
    unprocessed: 'Non trasformato',
    unresolved: 'Non riesci ancora a risolvere? Clic',
    unspecified: 'Confidenzialità',
    upToTopics: 'Possono essere aggiunti fino a %s argomenti',
    updateAuthenticationTime: 'Aggiorna il tempo di autenticazione',
    updateBy: 'Aggiornatore',
    updateSuccess: {},
    updateTime: 'Tempo di aggiornamento',
    updating: 'in aggiornamento',
    upgradeAgainDescription: "L'attività di aggiornamento è stata respinta. Seguire la [Guida] nella parte superiore della pagina corrente per connettere la rete di display TFT per l'aggiornamento.",
    upgradeAssistant: 'Aiuto',
    upgradeDescription: "Quando viene trovata una nuova versione, seguire la [Guida] nella parte superiore della pagina corrente per connettere la rete di display TFT per l'aggiornamento.",
    upgradeSuccessful: 'Upgrade riuscito',
    upgradeType: 'Metodo di aggiornamento',
    upload: 'Caricamento',
    uploadDisplayPicture: {},
    uploadFail: 'Caricamento fallito',
    uploadFailed: "Caricamento non riuscito, prova con un'altra rete",
    uploadFailedOfTry: 'Caricamento non riuscito, riprova',
    uploadFileMore1M: 'La dimensione del file di caricamento non supera 1M',
    uploadFiles: 'Carica file',
    uploadImageRules1To1: "Il formato dell'immagine deve essere jpg/jpeg/png, con un rapporto di immagine 1:1 e una dimensione massima di 5MB",
    uploadLog: 'Carica registro',
    uploadPicture: 'Caricare immagine',
    uploadQuantityExceed: 'Il numero di upload supera il limite',
    uploadSuccessful: 'Caricamento riuscito',
    uploadTime: 'Tempo di caricamento',
    uploadTip556_740: {},
    uploadVideoRules: 'È supportato solo il caricamento singolo di file video. Si consiglia che la dimensione di un singolo video non superi i 50 MB.',
    uploadVideoRules4To3: 'Formato video di supporto, rapporto raccomandato di 4:3, dimensione non superiore a 50MB',
    urlLink: 'Link URL',
    user: 'Utente',
    userAccount: 'Account utente',
    userEmail: 'E-mail',
    userGender: 'Genere dell’utente',
    userId: 'ID utente',
    userIdTemplate: 'Modello di importazione ID utente',
    userIdentity: 'ID utente',
    userLocalTime: "Tempo dell'utente finale",
    userLogin: 'Accesso',
    userMobilePhone: 'Cellulare',
    userModel: 'Modello di veicolo',
    userName: 'Nome utente',
    userName1: {},
    userNickname: "Soprannome dell'utente",
    userNum: 'Numero utente',
    userPhone: 'Numero di cellulare',
    userRealName: 'Nome vero',
    userReply: "In attesa di risposta da parte dell'utente",
    userStatus: 'Stato utente',
    userType: 'Tipo di utente',
    userUnbind: "Unbind l'utente",
    users: 'utenti',
    vacationTime: 'Tempo di vacanze',
    validNumberVolume: 'Numero di obiettivi validi',
    validNumerDescription: "numero di dispositivi rimanenti dopo il filtraggio del gruppo target selezionato per l'invio del task",
    validateAfter24Hours: 'Supporta solo selezioni temporali future entro 24 ore',
    validateEmail: "Il formato dell'indirizzo email è errato, controlla per favore.",
    validateImageRadio: "Requisiti del formato del file immagine:  %s, scala dell'immagine:  %s, non superiore a %s",
    validateImageSize: 'Requisiti del formato del file immagine:  %s, dimensione immagine consigliata:  %s, non superiore a %s',
    validatePhone: 'Errore nel formato del numero di telefono, controllare',
    validateVideo: 'Requisiti del formato del file video:  %s, non superiore a %s',
    validateVin: 'VIN errato, per favore verifica.',
    validationCodeError: 'Errore del codice di verifica',
    vechicleFirstBindTime: 'Tempo effettivo di primo vincolo del veicolo',
    vehicleAlarmDetails: 'Dettagli dell’allarme del veicolo',
    vehicleBindDuration: 'Durata di associazione del veicolo',
    vehicleBrochure: 'Brochure del veicolo',
    vehicleColor: 'Colore del veicolo',
    vehicleDetails: 'Dettagli del veicolo',
    vehicleDrivingLicense: 'Certificato di registrazione del veicolo.',
    vehicleFaultDetails: 'Dettagli di guasto del veicolo',
    vehicleGallery: 'Galleria dei veicoli',
    vehicleGalleryEntranceConfiguration:
      "Le immagini della pagina dello showroom di moto dell'APP e dell'ingresso della funzione Galleria dei veicoli sono tutte prese dalla seguente configurazione. Assicurati che le tre immagini siano completate nella configurazione.",
    vehicleGalleryEntranceSettings: 'Impostazioni di ingresso della galleria veicoli',
    vehicleGalleryUploadRules: 'Il requisito del formato immagine è jpg/jpeg/png. Si consiglia che la dimensione di una singola immagine non superi i 5 MB. È possibile importare un massimo di 10 immagini alla volta. Sono consentite importazioni multiple.',
    vehicleIdHomepageImage: 'Pagina principale del certificato di registrazione del veicolo con nome del proprietario e numero di identificazione del veicolo (VIN).',
    vehicleModel: 'Modello di veicolo',
    vehicleModelAlbum: 'Album modello',
    vehicleModelCategorySort: 'Ordina per categoria di veicolo',
    vehicleModelDescription: 'Descrizione del Modello',
    vehicleModelList: 'Elenco dei modelli',
    vehicleModelManagement: 'Gestione dei modelli di veicoli',
    vehicleModelName: 'Nome del modello',
    vehicleModelQuery: 'Interrogazione sul modello del veicolo',
    vehicleModelSeries: 'Serie di modelli',
    vehicleModelSorting: 'Ordinamento dei modelli',
    vehicleModelType: 'Tipo di modello',
    vehicleName: 'Nome del veicolo',
    vehicleNetworkEquipment: 'Dispositivo di rete del veicolo',
    vehicleOutboundCountry: 'Paese di uscita del veicolo',
    vehicleRemark: 'Osservazioni relative al veicolo',
    vehicleShareInstruction: 'Istruzioni per la condivisione dei veicoli',
    vehicleShareInstructionAdd: 'Istruzioni per la condivisione dei veicoli nuovi',
    vehicleShareInstructionEdit: 'Modifica le istruzioni per la condivisione del veicolo',
    vehicleType: 'Numero del motor',
    vehicleTypeSplicing: 'Modello di feedback',
    vehicleUnbindingInstructions: 'Istruzioni per la richiesta di svincolamento del veicolo',
    verifyCodeSendFail: 'Invio del codice di verifica fallito',
    verifyCodeSendSuccess: 'Accesso non riuscito',
    versionCode: 'Numero della versione',
    versionIntroduction: 'Introduzione alla versione',
    versionManage: 'Gestione delle versioni',
    versionManageList: 'Elenco di gestione delle versioni',
    versionMangeTip:
      'Nota: non è consentito creare una versione più grande del numero di versione attualmente pubblicato nel mercato delle app! Il personale operativo e di manutenzione deve attendere il rilascio della versione più recente su Google Play o App Store, quindi creare record di versione corrispondenti al numero di versione più recente. Non è consentita la creazione di record in anticipo.',
    versionPattern: 'Il numero di versione può essere inserito solo come numero intero compreso tra 0 e 999.',
    versionRequired: 'Il numero di versione non può essere vuoto',
    vhDataBasicService: 'Servizio base dei dati del veicolo',
    video: 'video',
    videoContent: 'Contenuti video',
    videoCover: 'Copertina del video',
    videoDetail: 'Dettagli video',
    videoDisplayImages: 'Visualizzazione video',
    videoFile: 'File video',
    videoGuide: 'Configurazione di avvio video',
    videoImageValidate: 'Requisiti del formato del file immagine: png jpg jpeg, rapporto immagine 16:9, dimensione non superiore a 5 MB',
    videoList: 'Elenco dei video',
    videoMaxSizeValidate: 'La dimensione del video non può superare i 150 MB',
    videoSizeExceed: 'Carica un video con larghezza e altezza di %s',
    viewAllComment: 'Visualizza tutti i commenti',
    viewCount: 'conteggio delle visualizzazioni',
    viewCurrentLocation: "Apri l'APP per visualizzare la posizione corrente del veicolo in qualsiasi momento",
    viewCurrentLocation2: "Apri l'APP per visualizzare la posizione corrente del veicolo in qualsiasi momento, utile per trovare veicoli a distanza ravvicinata",
    viewDetails: 'Visualizza dettagli',
    viewFeedBackRecords: 'Visualizza record di feedback',
    viewLocation: "Apri l'APP per verificare in qualsiasi momento la posizione del veicolo",
    viewModel: {},
    viewPush: 'Visualizza Spinta',
    viewSeries: {},
    viewVehicleInfomation: 'Supporto per visualizzare la traccia di guida giornaliera, il chilometraggio, la durata, la velocità e altre informazioni del veicolo',
    views: 'Visualizzazioni',
    vin: 'VIN',
    virginia: 'Virginia',
    waitForReview: 'In attesa di revisione',
    waitUploading: 'Caricamento in corso, attendere',
    waitingManualReview: 'In attesa di revisione manuale',
    waitingOnline: {},
    waitingPush: 'In attesa',
    wednesday: 'Mercoledì',
    whatOTA: "Cos'è l'OTA?",
    whyUseNavigation: 'Come utilizzare la navigazione',
    whyUseSetting: "Come configurare le impostazioni generali dell'APP",
    withCountry: 'Paese/regione (IP)',
    withInformation: 'Con informazioni',
    withTBOX: {},
    withdrawn: 'Revocato',
    withoutCarOfNumber: 'Numero di utenti senza auto',
    withoutTBOX: {},
    writeAccountToPass: "Compila le informazioni dell'account e completa la verifica dell'identità",
    year: {},
    yes: 'Sì',
    youHaveFeedbackMessage: 'Hai ** feedback degli utenti che non sono stati seguiti in modo efficace, ti preghiamo di gestirli in tempo',
    youthVehicleOwner: {},
    yoyGrowth: 'Aumentato su base annua',
    zh_CN: 'Cinese',
  },
};
